import { Phone, MapPin, Mail, Clock, Facebook, Linkedin, Instagram, ChevronRight, Zap } from 'lucide-react';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer id="contacto" className="w-full bg-[#031a29] text-white pt-32 pb-12 overflow-hidden relative border-t border-white/5">
      <div className="section-container relative z-10">
        {/* Background Gradients */}
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-accent/10 rounded-full blur-[120px] -mr-64 -mt-64 pointer-events-none" />
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-energy-blue/5 rounded-full blur-[100px] -ml-32 -mb-32 pointer-events-none" />

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-16 mb-24 relative z-10">
          <div className="space-y-10">
            <a href={`${import.meta.env.BASE_URL}`} className="inline-block group">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-white rounded-2xl flex items-center justify-center p-2 shadow-lg">
                  <img
                    src={`${import.meta.env.BASE_URL}images/logo.svg`}
                    alt="CIAC Group"
                    className="w-full h-auto"
                  />
                </div>
                <div className="flex flex-col">
                  <span className="text-white font-bold tracking-tight text-xl leading-none">CIAC Group</span>
                  <span className="text-white/60 text-[10px] uppercase tracking-widest mt-1">Energy Solutions</span>
                </div>
              </div>
            </a>
            <p className="text-slate-400 leading-relaxed text-sm">
              Líderes en ingeniería eléctrica y eficiencia energética. Desarrollamos soluciones sostenibles para la industria del futuro, impulsando la transición hacia una economía baja en carbono.
            </p>
            <div className="flex gap-4">
              {[
                { icon: <Linkedin size={20} />, href: 'https://www.linkedin.com/company/ciac-group/' },
                { icon: <Instagram size={20} />, href: '#' },
                { icon: <Facebook size={20} />, href: '#' }
              ].map((social, i) => (
                <a
                  key={i}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 rounded-2xl bg-white/5 border border-white/10 flex items-center justify-center text-white/40 hover:bg-accent hover:text-white hover:border-accent transition-all duration-500 hover:-translate-y-1"
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>

          <div className="lg:pl-8">
            <h4 className="text-sm font-black uppercase tracking-[0.2em] mb-10 text-white/50">
              Soluciones
            </h4>
            <ul className="space-y-4">
              {[
                { name: 'Proyectos Eléctricos', link: '#servicios' },
                { name: 'Bombas de Calor', link: '#bombas-calor' },
                { name: 'Energía Solar', link: '#servicios' },
                { name: 'Eficiencia Energética', link: '#eficiencia' },
                { name: 'Auditorías ISO 50001', link: '#servicios' }
              ].map((item, i) => (
                <li key={i}>
                  <a href={item.link} className="text-slate-400 hover:text-accent transition-colors text-sm font-medium flex items-center gap-2 group">
                    <ChevronRight size={14} className="opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all text-accent" />
                    {item.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:pl-8">
            <h4 className="text-sm font-black uppercase tracking-[0.2em] mb-10 text-white/50">
              Corporativo
            </h4>
            <ul className="space-y-4">
              {[
                { name: 'Sobre Nosotros', href: '#nosotros' },
                { name: 'Casos de Éxito', href: '#casos-exito' },
                { name: 'Portafolio', href: '#proyectos' },
                { name: 'Trabaja con Nosotros', href: '#' },
                { name: 'Contacto', href: '#contacto' }
              ].map((item) => (
                <li key={item.name}>
                  <a href={item.href} className="text-slate-400 hover:text-energy-blue transition-colors text-sm font-medium flex items-center gap-2 group">
                    {item.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="bg-white/5 rounded-[2.5rem] p-10 border border-white/10">
            <h4 className="text-sm font-black uppercase tracking-[0.2em] mb-10 text-white/50">
              Contacto
            </h4>
            <ul className="space-y-8">
              <li className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-xl bg-accent flex items-center justify-center flex-shrink-0 text-white shadow-lg shadow-accent/20">
                  <Phone size={18} />
                </div>
                <div>
                  <div className="text-white/30 text-[9px] uppercase font-bold tracking-widest mb-1">Central</div>
                  <a href="tel:+56976690460" className="text-sm font-black hover:text-accent transition-colors">+56 9 7669 0460</a>
                </div>
              </li>
              <li className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-xl bg-energy-blue flex items-center justify-center flex-shrink-0 text-white shadow-lg shadow-energy-blue/20">
                  <Mail size={18} />
                </div>
                <div>
                  <div className="text-white/30 text-[9px] uppercase font-bold tracking-widest mb-1">Email</div>
                  <a href="mailto:contacto@ciacgroup.cl" className="text-sm font-black hover:text-accent transition-colors break-all">contacto@ciacgroup.cl</a>
                </div>
              </li>
              <li className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-xl bg-white/10 flex items-center justify-center flex-shrink-0 text-white">
                  <MapPin size={18} />
                </div>
                <div>
                  <div className="text-white/30 text-[9px] uppercase font-bold tracking-widest mb-1">Ubicación</div>
                  <span className="text-sm font-black">Región Metropolitana, Chile</span>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-12 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-8 relative z-10">
          <div className="flex flex-col md:flex-row items-center gap-8">
            <p className="text-white/30 text-[10px] uppercase tracking-[0.2em] font-bold">
              © {currentYear} CIAC Energy SpA. All Rights Reserved.
            </p>
            <div className="flex items-center gap-2 text-white/40 text-[10px] font-bold uppercase tracking-widest">
              <Clock size={14} className="text-accent" />
              <span>Lun - Vie 9:00 - 18:00</span>
            </div>
          </div>
          <div className="flex items-center gap-8">
            <a href="#" className="flex items-center gap-2 text-white/40 hover:text-accent text-[10px] font-black uppercase tracking-[0.3em] transition-all group">
              Back to Top
              <Zap size={12} className="group-hover:text-accent transition-colors" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}


